import { Container } from 'inversify';

/**
 * container に 各 Model を登録する
 */
const container = new Container();

export default container;
